import { action } from 'satcheljs';
import { TxpSettingsDialogViewState } from '../store/viewSchema/TxpSettingsDialogViewState';
import TxpSettingsDialogViewStates from '../store/viewSchema/TxpSettingsDialogViewStates';

export const setTxpSettingsDialogViewState = action(
    'SET_TXP_SETTINGS_DIALOG_VIEW_STATE',
    (txpSettingsDialogViewStateToSet: TxpSettingsDialogViewState) => ({
        txpSettingsDialogViewStateToSet,
    })
);

export const setTxpSettingsErrorDialogViewState = action(
    'SET_TXP_SETTINGS_ERROR_DIALOG_VIEW_STATE',
    (txpSettingsErrorDialogViewStateToSet: TxpSettingsDialogViewStates) => ({
        txpSettingsErrorDialogViewStateToSet,
    })
);
